module.exports = __webpack_public_path__ + "static/media/voice_default.8f394633.gif";